import request from '@/utils/request'

export function getMemberConfig() {
  return request({ url: '/admin/member/config', method: 'post', data: {} })
}

export function getMemberList(data) {
  return request({ url: '/admin/member/list', method: 'post', data })
}

export function createMember(data) {
  return request({ url: '/admin/member/create', method: 'post', data })
}

export function updateMember(data) {
  return request({ url: '/admin/member/update', method: 'post', data })
}

export function deleteMember(data) {
  return request({ url: '/admin/member/delete', method: 'post', data })
}

export function getMemberDetail(data) {
  return request({ url: '/admin/member/detail', method: 'post', data })
}

export function resetMemberPassword(data) {
  return request({ url: '/admin/member/resetPassword', method: 'post', data })
}

export function uploadMemberAvatar(data) {
  return request({ url: '/admin/member/uploadAvatar', method: 'post', data })
}

export function getMemberBalanceLogs(data) {
  return request({ url: '/admin/member/balanceLogs', method: 'post', data })
}

export function getMemberPointsLogs(data) {
  return request({ url: '/admin/member/pointsLogs', method: 'post', data })
}

export function adjustMemberBalance(data) {
  return request({ url: '/admin/member/adjustBalance', method: 'post', data })
}

export function adjustMemberPoints(data) {
  return request({ url: '/admin/member/adjustPoints', method: 'post', data })
}

export function bindMemberPartner(data) {
  return request({ url: '/admin/member/bindPartner', method: 'post', data })
}
